import Flickity from 'flickity'
import $ from 'jquery'

const VideoAppSlider = (() => {
  const init = () => {

    var slider = document.querySelector('.c-video-slider');

    
    if (slider) {
      const next = document.createElement('div')
      next.classList.add('c-video-slider__next')
      next.classList.add('c-video-slider__next--app')
      next.innerText = 'Next'
      slider.appendChild(next)
  
      const prev = document.createElement('div')
      prev.classList.add('c-video-slider__prev')
      prev.classList.add('c-video-slider__prev--app')
      prev.innerText = 'Prev'
      slider.appendChild(prev)
  
      // initialize slider
      var flikitySlider = new Flickity(slider, {
        cellSelector: '.js-video-slider-slide',
        cellAlign: 'left',
        pageDots: false,
        freeScroll: true,
        prevNextButtons: false,
        wrapAround: true,
        draggable: false,
      })
        next.addEventListener('click', (e) => {
          e.preventDefault()
          
          flikitySlider.next()
        })
        prev.addEventListener('click', (e) => {
          e.preventDefault()
          
          flikitySlider.previous()
        })
    }

    $('#extra-lessons').on('change', function(){
      setTimeout(function(){ 
        var extraLessons = $('#extra-lessons').val()
        
        $(".add-training").each(function(){
          var traininglink = $(this).attr('href')
          traininglink = traininglink + '&cards=' + extraLessons
          $(this).attr('href', traininglink)
        });

        if (extraLessons !== 0) {
          $(".pt-price").each(function(){
            var price = $(this).attr('data-price')
            var month = $(this).attr('data-month')
            price = parseInt(price)
            price = price + extraLessons * month * 50
            $(this).find('b').text(price + '.00')
          });
        }
      }, 300);
    });



  }

  return {
    init,
  }
})()

export default VideoAppSlider



// WEBPACK FOOTER //
// app/javascript/scripts/components/App.js